import { map, sortBy, toLower, uniqBy, trim, filter } from 'lodash';

import * as ActionTypes from '../components/actions/types';

const arrangeOptions = tags =>
  filter(
    sortBy(uniqBy(tags, 'value'), 'value'),
    t => t.key !== '' && t.value !== '' && t.text !== '',
  );

const cleanString = str => toLower(trim(str));

const convertTagsToOptions = tags =>
  arrangeOptions(
    map(tags, t => ({
      value: cleanString(t.name),
      label: cleanString(t.name)
    })),
  );

function tagReducer(state = { tagOptions: [] }, action) {
  switch (action.type) {
    case ActionTypes.FETCH_TAGS:
      return {
        ...state,
        tagOptions: convertTagsToOptions(action.payload)
      };
    case ActionTypes.ADD_TAG:
      return {
        ...state,
        tagOptions: arrangeOptions([...state.tagOptions, action.payload])
      };
    default: {
      return state;
    }
  }
}

export default tagReducer;



// WEBPACK FOOTER //
// ./src/reducers/tag.js